import { forwardRef } from 'react';

export const LocationIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M10.0003 11.6667C11.8387 11.6667 13.3337 10.1717 13.3337 8.33333C13.3337 6.495 11.8387 5 10.0003 5C8.16199 5 6.66699 6.495 6.66699 8.33333C6.66699 10.1717 8.16199 11.6667 10.0003 11.6667ZM10.0003 6.66667C10.9195 6.66667 11.667 7.41417 11.667 8.33333C11.667 9.2525 10.9195 10 10.0003 10C9.08116 10 8.33366 9.2525 8.33366 8.33333C8.33366 7.41417 9.08116 6.66667 10.0003 6.66667Z"
          fill="currentColor"
        />
        <path
          d="M9.51642 18.1782C9.66142 18.2815 9.83058 18.3332 9.99975 18.3332C10.1689 18.3332 10.3381 18.2815 10.4831 18.1782C10.7364 17.999 16.6906 13.6998 16.6664 8.33317C16.6664 4.65734 13.6756 1.6665 9.99975 1.6665C6.32391 1.6665 3.33308 4.65734 3.33308 8.329C3.30891 13.6998 9.26308 17.999 9.51642 18.1782ZM9.99975 3.33317C12.7572 3.33317 14.9997 5.57567 14.9997 8.33734C15.0172 12.0357 11.3431 15.3565 9.99975 16.4457C8.65725 15.3557 4.98225 12.034 4.99975 8.33317C4.99975 5.57567 7.24225 3.33317 9.99975 3.33317Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
